import './ProductStamp.less';
import React, {useState, useEffect} from 'react';
import ImageView from "../image-view/ImageView";
import Products from "../../../models/product/Products";
import __ from '../../../i18n';
import conditionLevels from '../../../model-constants/product/conditionLevels';

export default function ProductStamp({product, promotion, images}) {

    return <div className="product-stamp">
        <ImageView
            image={images.find(t => t.id === product.avatar_image_id)}
            ratio={1}
        />
        <div className="lines">
            <div className="name">{product.name}</div>
            <div className="tags">
                <div className="tag">
                    {conditionLevels.get(product.condition_level).label}
                </div>
            </div>
            <div className="price">
                {
                    product.is_price_public
                        ? __(':price(CURRENCY)', {price: Products.getSalePrice(product, promotion)})
                        : __('Contact for price')
                }
            </div>
        </div>
    </div>;
}
